import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {ScheduleFormatter} from "../../Schedule";

const ScheduleColumn = memo(({feedExport}) => {

  return (
    <td className="pt-4 text-wrap text-xs">
      <ScheduleFormatter schedule={feedExport.schedule}/>
    </td>
  );
});

ScheduleColumn.propTypes = {
  feedExport: PropTypes.object.isRequired,
};

export default ScheduleColumn;
